import * as React from 'react';
import Lottie from 'react-lottie';
import RestService from '../../../RestService';

interface Props {
  url?: string;
}

interface State {
  lottieData?: string;
}

class LottieAnimation extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      lottieData: null,
    };
  }

  componentDidMount() {
    this.setData();
  }

  dataHandler = (result) => {
    this.setState({
      lottieData: result,
    });
  };

  setData = () => {
    RestService.getCDNData((result) => {
      // console.log(result);
      this.dataHandler(result);
    }, this.props.url);
  };

  render() {
    return (
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: this.state.lottieData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
          },
        }}
        height={32}
        width={32}
      />
    );
  }
}

export { LottieAnimation };



// WEBPACK FOOTER //
// ./src/pages/drafts/components/LottieWrapper.tsx